import request from '@/utils/request'

export function getTemplateBookmarks(templateId) {
  return request({
    url: '/api/template-bookmark/list',
    method: 'get',
    params: { templateId }
  })
}

export function addTemplateBookmark(data) {
  return request({
    url: '/api/template-bookmark/add',
    method: 'post',
    data
  })
}

export function updateTemplateBookmark(data) {
  return request({
    url: '/api/template-bookmark/update',
    method: 'put',
    data
  })
}

export function deleteTemplateBookmark(bookmarkId) {
  return request({
    url: `/api/template-bookmark/delete/${bookmarkId}`,
    method: 'delete'
  })
}

export function moveTemplateBookmark({ bookmarkId, direction }) {
  return request({
    url: '/api/template-bookmark/move',
    method: 'post',
    data: { bookmarkId, direction }
  })
} 